import ClusterRecommendations from '@/components/feature/ClusterRecommendations';

export default function ReadNextSection() {
  return <ClusterRecommendations cluster="encyclopedia" currentPage="/enciklopediya-korporativnogo-obucheniya/adaptaciya-sotrudnikov" />;
}